import { HrPrimary } from '@components/styles/hr-styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { IconWrapper, ToastContainer } from '@components/v1/Toast/styles';

export const Toast = ({ message, duration, onClose, iconClassName, title, color }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <ToastContainer color={color}>
      {iconClassName && <IconWrapper className={iconClassName} />}
      {(title || message) && (
        <div>
          {title && <strong>{title}</strong>}
          {message && <div>{message}</div>}
        </div>
      )}
    </ToastContainer>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  iconClassName: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string
};

Toast.defaultProps = {
  duration: 5000,
  color: HrPrimary,
  onClose: () => {},
  iconClassName: 'hr-Checkmark',
  title: ''
};
